
const path = window.location.pathname;
const isProductPage = path.startsWith('/products/');

if(isProductPage) {
    (function () {
  const TARGET_SELECTOR = '.alireviews-review-star-rating';

  let lastText = null;

  const handleUpdateSREle = () => {
    const el = document.querySelector(TARGET_SELECTOR);

    if (!el) return;

    const text = el.textContent.trim();
    if (text && text !== lastText) {
      lastText = text;
      console.log('[AliReviews] Element loaded / changed:', text);

        //update SR
        const createSpan = (className, text) => {
            const span = document.createElement('span');
            span.className = className;
            span.textContent = text;
            return span;
        };

        const el = document.querySelector('.alr-wh-review-star-rating-number');
        if (!el) return;

        const parts = el.textContent.trim().split(/\s+/);

        if (parts.length < 5) return;

        el.textContent = '';

        el.append(
            createSpan('custom-rated-text', parts[0]), ' ',
            createSpan('custom-rating-text', `${parts[1]} ${parts[2]}`), ' ',
            createSpan('custom-review-text', `${parts[3]} ${parts[4]}`)
        );
    }
  };

  //DOM ready
  handleUpdateSREle();

  const observer = new MutationObserver(() => {
    handleUpdateSREle();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
}